import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = {
  key: 0,
  class: "filter-box"
}
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "split-table-layout" }
const _hoisted_14 = {
  key: 0,
  class: "icon",
  "aria-hidden": "true",
  "font-size": "20px"
}
const _hoisted_15 = ["xlink:href"]
const _hoisted_16 = {
  key: 1,
  class: "statusStyle yellowStatusStyle"
}
const _hoisted_17 = { class: "status" }
const _hoisted_18 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_19 = { class: "tab-title_left fl" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_DeliverTable = _resolveComponent("DeliverTable")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_FormDeliverComponent = _resolveComponent("FormDeliverComponent")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.no) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.name) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "品牌", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.brand,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.brand) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "型号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.model) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "业务员", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.salesManId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.salesManId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesManOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              (_ctx.isExistEngineerFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "工程师", -1)),
                    _createVNode(_component_el_select, {
                      filterable: true,
                      modelValue: _ctx.listQuery.engineerId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.engineerId) = $event)),
                      class: "filter-item",
                      placeholder: "",
                      size: _ctx.t('table.btnSize'),
                      clearable: "",
                      onChange: _ctx.handleFilter
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.engineerOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.mark,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "size", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.listQuery.completed,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.completed) = $event)),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: false,
                      label: false
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("未完成", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: true,
                      label: true
                    }, {
                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                        _createTextVNode("完成", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: null,
                      label: null
                    }, {
                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                        _createTextVNode("全部", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[27] || (_cache[27] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[28] || (_cache[28] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: rf => { if (rf) _ctx.tableDataRef[0] = rf },
            dataList: _ctx.list,
            total: _ctx.total,
            columnAllData: _ctx.columnAllData,
            page: _ctx.listQuery.page,
            size: _ctx.listQuery.size,
            tableName: _ctx.TableName,
            handleDefaultWidth: 130,
            permissionName: _ctx.permissionName,
            onCommandChange: _ctx.handleCommand,
            "can-refresh": false,
            "can-change-column": false,
            highlightCurrentRow: true,
            isShowPagination: false,
            newHpx: _ctx.newHpx,
            style: {"height":"100%","overflow":"hidden"}
          }, {
            no: _withCtx((scope) => [
              (scope.row.changeStatus !== '申请取消')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (scope.row.urgentIcon)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_14, [
                          _createElementVNode("use", {
                            "xlink:href": '#' + scope.row.urgentIcon
                          }, null, 8, _hoisted_15)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(scope.row.no), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                    (['申请取消'].includes(scope.row.changeStatus))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[29] || (_cache[29] = _createElementVNode("i", { class: "iconfont icon-tubiao-40" }, null, -1)),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(scope.row.changeStatus), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(scope.row.no), 1)
                  ]))
            ]),
            completed: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.completed ? '已完成' : '未完成'), 1)
            ]),
            repairTimes: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.repairTimes || 0), 1)
            ]),
            "operation-action": _withCtx((scope) => [
              (scope.row.changeStatus !== '申请取消')
                ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    href: "javascript:void(0);",
                    class: "mr-10",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleCommand('action', scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.repairTypeName), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_permission, { pkey: `${_ctx.permissionName}_ACTION` }]
                  ])
                : _createCommentVNode("", true),
              (!scope.row.completed)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                    key: 1,
                    href: "javascript:void(0);",
                    class: "mr-10",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleCommand('materDelivery', scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                      _createTextVNode(" 材料出库 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_permission, { pkey: `${_ctx.permissionName}_ACTION` }]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["dataList", "total", "columnAllData", "page", "size", "tableName", "permissionName", "onCommandChange", "newHpx"])), [
            [_directive_loading, _ctx.listLoading]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("ul", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_20))
              }), 128))
            ])
          ]),
          (_ctx.tabList.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.activeTab === 1)
                  ? (_openBlock(), _createBlock(_component_DeliverTable, {
                      key: 0,
                      ref: "DeliverTable",
                      id: _ctx.activeId
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible && !_ctx.materDeliveryVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          detail: _ctx.activeDetail,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'repair',
          handleResolveTempData: _ctx.handleResolveTempData,
          "onUpdate:visibel": _cache[12] || (_cache[12] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "detail", "dialogFormVisible", "handleResolveTempData"]))
      : _createCommentVNode("", true),
    (_ctx.materDeliveryVisible)
      ? (_openBlock(), _createBlock(_component_FormDeliverComponent, {
          key: 1,
          id: _ctx.activeId,
          type: "BUSINESS",
          detail: _ctx.activeDetail,
          api: 'purchase',
          handleResolveTempData: _ctx.handleResolveTempData,
          "onUpdate:visibel": _cache[14] || (_cache[14] = () => _ctx.materDeliveryVisible = false),
          onSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "detail", "handleResolveTempData"]))
      : _createCommentVNode("", true),
    (!_ctx.dialogFormVisible && !_ctx.materDeliveryVisible && _ctx.tabList.length)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}